import { isDefined } from "@clipboard-health/util-ts";

import {
  BookabilityDecision,
  type BookabilityStatusItem,
  type BookabilityUnmetCriteria,
} from "./types";
/**
 * Simple helper for determining if a shift is blocked due to a specific unmet criteria
 * Reduces boilerplate
 */
export function hasUnmetBookabilityCriteria(
  bookabilityStatus: BookabilityStatusItem | undefined,
  unmetCriteria: BookabilityUnmetCriteria[]
) {
  if (!isDefined(bookabilityStatus)) {
    return false;
  }

  if (bookabilityStatus.attributes.bookability.decision === BookabilityDecision.BLOCKED) {
    return bookabilityStatus.attributes.bookability.unmetCriteria.some((criteria) =>
      unmetCriteria.includes(criteria)
    );
  }

  return false;
}

/**
 * Helper to determine if a shift is blocked due to additional criteria beyond the supplied
 */
export function hasAdditionalUnmetBookabilityCriteria(
  bookabilityStatus: BookabilityStatusItem | undefined,
  unmetCriteria: BookabilityUnmetCriteria[]
) {
  if (!isDefined(bookabilityStatus)) {
    return false;
  }

  if (bookabilityStatus.attributes.bookability.decision === BookabilityDecision.BLOCKED) {
    const additionalUnmetCriteria = bookabilityStatus.attributes.bookability.unmetCriteria.filter(
      (criteria) => !unmetCriteria.includes(criteria)
    );

    return additionalUnmetCriteria.length > 0;
  }

  return false;
}
